import React, { useState, useEffect } from "react";
import { FaStream, FaRegEdit, FaAngleRight } from "react-icons/fa";
import Cookies from "universal-cookie";
import axios from "axios";
import { SpinnerCircular } from "spinners-react";
import { FaTimesCircle } from "react-icons/fa";
import DoneMessages from "../Utils/DoneMessage";

const check = require("../../assets/images/check.png");
require("../../assets/stylesheets/Judges/Judges.css");

const cookie = new Cookies();

var loading = false;

const Panel = () => {
  const [text, setText] = useState("");
  const [code, setCode] = useState(200);
  const [messageView, setMessageView] = useState(false);

  const [dataCategories, setDataCategories] = useState([]);
  const [dataProjects, setDataProjects] = useState([]);
  const [activateItem, setActivateItem] = useState("");

  const [qualify, setQualify] = useState(false);
  const [dataQualify, setDataQualify] = useState([]);

  useEffect(() => {
    axios
      .post(
        "https://ferias-ingenio-backend.vercel.app/api/categories/getcategorie",
        {
          id: cookie.get("id"),
        }
      )
      .then(async (res) => {
        await setDataCategories(res.data);
      })
      .catch((err) => {
        if (err) console.log(err);
      });
  }, [qualify, messageView]);

  const visiblePanelTrue = (project) => {
    setQualify(true);
    setDataQualify(project);
    console.log(project);
  };

  const visiblePanelFalse = (idCategory) => {
    setMessageView(false);
    setQualify(false);
    setDataQualify([]);
    axios
      .post(
        "https://ferias-ingenio-backend.vercel.app/api/projects/getprojects",
        { id: idCategory }
      )
      .then((res) => {
        setDataProjects(res.data);
        console.log(res.data);
        loading = false;
      })
      .catch((err) => {
        console.log(err);
      });
  };
  //PANEL DE FORMULARIO DE CALIFICACION
  const QualifyPanel = () => {
    const [noteItem1, setNoteItem1] = useState(0);
    const [noteItem2, setNoteItem2] = useState(0);
    const [noteItem3, setNoteItem3] = useState(0);
    const [noteItem4, setNoteItem4] = useState(0);
    const [noteItem5, setNoteItem5] = useState(0);
    const [noteItem6, setNoteItem6] = useState(0);
    const [noteItem7, setNoteItem7] = useState(0);
    const [noteItem8, setNoteItem8] = useState(0);
    const [noteItem9, setNoteItem9] = useState(0);
    const [noteItem10, setNoteItem10] = useState(0);

    const [videoVisibility, setVideoVisibility] = useState(false);

    const note1 = (e) => {
      setNoteItem1(e.currentTarget.value);
    };
    const note2 = (e) => {
      setNoteItem2(e.currentTarget.value);
    };
    const note3 = (e) => {
      setNoteItem3(e.currentTarget.value);
    };
    const note4 = (e) => {
      setNoteItem4(e.currentTarget.value);
    };
    const note5 = (e) => {
      setNoteItem5(e.currentTarget.value);
    };
    const note6 = (e) => {
      setNoteItem6(e.currentTarget.value);
    };
    const note7 = (e) => {
      setNoteItem7(e.currentTarget.value);
    };
    const note8 = (e) => {
      setNoteItem8(e.currentTarget.value);
    };
    const note9 = (e) => {
      setNoteItem9(e.currentTarget.value);
    };
    const note10 = (e) => {
      setNoteItem10(e.currentTarget.value);
    };

    let totalNote =
      +noteItem1 +
      +noteItem2 +
      +noteItem3 +
      +noteItem4 +
      +noteItem5 +
      +noteItem6 +
      +noteItem7 +
      +noteItem8 +
      +noteItem9 +
      +noteItem10;

    const setAssessment = (code) => {
      if (window.confirm("Seguro de la nota puesta?")) {
        axios
          .post(
            "https://ferias-ingenio-backend.vercel.app/api/projects/setqualify",
            {
              user: cookie.get("id"),
              note: totalNote,
              code,
            }
          )
          .then((res) => {
            setText(res.data.message);
            setCode(res.data.code);
            setMessageView(true);
            setTimeout(() => visiblePanelFalse(), 3000);
          })
          .then((err) => {});
      }
    };

    const videoShow = () => {
      setVideoVisibility(true);
    };

    const VideoView = ({ videoCode }) => {
      let projectUrl = "https://www.youtube.com/embed/" + videoCode;
      return (
        <div className="videoView">
          <span
            onClick={() => {
              setVideoVisibility(false);
            }}
          >
            <FaTimesCircle />{" "}
          </span>
          <iframe
            width="100%"
            height="100%"
            src={projectUrl}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      );
    };

    return (
      <div className="qualifyPanel">
        {messageView && (
          <DoneMessages text={text} code={code} visibility={messageView} />
        )}
        {videoVisibility && <VideoView videoCode={dataQualify.code} />}
        <span
          onClick={() => {
            visiblePanelFalse(dataQualify.idCategory);
          }}
        >
          <FaTimesCircle />{" "}
        </span>
        <div className="qualifyInfo">
          <b>Título: </b>
          <p>{dataQualify.title}</p>
          <b>Descripción: </b>
          <p>{dataQualify.description}</p>
          <b>Cordinador: </b>
          <p>{dataQualify.coordinator}</p>
          <p>
            <b>Integrantes de equipo: </b>
            <textarea value={dataQualify.team} disabled></textarea>
          </p>
          <b>Clase: </b>
          <p>{dataQualify.matter}</p>
          <b>Catedrático(a): </b>
          <p>{dataQualify.master}</p>
          <p>
            <button onClick={videoShow}>Video</button>
          </p>
        </div>
        <div className="qualifyForm">
          <h2>Formulario de evaluación para {dataQualify.title}</h2>
          <div className="formContent">
            <form className="form-qualify">
              <h5>1. Proyecto</h5>
              <p>Claridad de la idea</p>
              <div className="formGroup">
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp1"
                    value="2"
                    id="val2"
                    onClick={note1}
                  />
                  <label for="val2">2</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp1"
                    value={4}
                    id="val4"
                    onClick={note1}
                  />
                  <label for="val4">4</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp1"
                    value={6}
                    id="val6"
                    onClick={note1}
                  />
                  <label for="val6">6</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp1"
                    value={8}
                    id="val8"
                    onClick={note1}
                  />
                  <label for="val8">8</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp1"
                    value={10}
                    id="val10"
                    onClick={note1}
                  />
                  <label for="val10">10</label>
                </div>
              </div>

              <p>Funcionalidad</p>
              <div className="formGroup">
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp2"
                    value={2}
                    id="val2"
                    onChange={note2}
                  />
                  <label for="val2">2</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp2"
                    value={4}
                    id="val4"
                    onChange={note2}
                  />
                  <label for="val4">4</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp2"
                    value={6}
                    id="val6"
                    onChange={note2}
                  />
                  <label for="val6">6</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp2"
                    value={8}
                    id="val8"
                    onChange={note2}
                  />
                  <label for="val8">8</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp2"
                    value={10}
                    id="val10"
                    onChange={note2}
                  />
                  <label for="val10">10</label>
                </div>
              </div>

              <p>Presentación (estética)</p>
              <div className="formGroup">
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp3"
                    value={2}
                    id="val2"
                    onClick={note3}
                  />
                  <label for="val2">2</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp3"
                    value={4}
                    id="val4"
                    onClick={note3}
                  />
                  <label for="val4">4</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp3"
                    value={6}
                    id="val6"
                    onClick={note3}
                  />
                  <label for="val6">6</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp3"
                    value={8}
                    id="val8"
                    onClick={note3}
                  />
                  <label for="val8">8</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp3"
                    value={10}
                    id="val10"
                    onClick={note3}
                  />
                  <label for="val10">10</label>
                </div>
              </div>

              <p>Alcance futuro de la ídea del proyecto</p>
              <div className="formGroup">
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp4"
                    value={2}
                    id="val2"
                    onClick={note4}
                  />
                  <label for="val2">2</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp4"
                    value={4}
                    id="val4"
                    onClick={note4}
                  />
                  <label for="val4">4</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp4"
                    value={6}
                    id="val6"
                    onClick={note4}
                  />
                  <label for="val6">6</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp4"
                    value={8}
                    id="val8"
                    onClick={note4}
                  />
                  <label for="val8">8</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp4"
                    value={10}
                    id="val10"
                    onClick={note4}
                  />
                  <label for="val10">10</label>
                </div>
              </div>
              <hr />

              <h5>2. Programa y Defensa del proyecto</h5>
              <p>Dominio y conocimiento del Tema</p>
              <div className="formGroup">
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp5"
                    value={2}
                    id="val2"
                    onClick={note5}
                  />
                  <label for="val2">2</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp5"
                    value={4}
                    id="val4"
                    onClick={note5}
                  />
                  <label for="val4">4</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp5"
                    value={6}
                    id="val6"
                    onClick={note5}
                  />
                  <label for="val6">6</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp5"
                    value={8}
                    id="val8"
                    onClick={note5}
                  />
                  <label for="val8">8</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp5"
                    value={10}
                    id="val10"
                    onClick={note5}
                  />
                  <label for="val10">10</label>
                </div>
              </div>

              <p>Estructura de la presentación</p>
              <div className="formGroup">
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp6"
                    value={2}
                    id="val2"
                    onClick={note6}
                  />
                  <label for="val2">2</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp6"
                    value={4}
                    id="val4"
                    onClick={note6}
                  />
                  <label for="val4">4</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp6"
                    value={6}
                    id="val6"
                    onClick={note6}
                  />
                  <label for="val6">6</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp6"
                    value={8}
                    id="val8"
                    onClick={note6}
                  />
                  <label for="val8">8</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp6"
                    value={10}
                    id="val10"
                    onClick={note6}
                  />
                  <label for="val10">10</label>
                </div>
              </div>

              <p>Innovación en presentación y defensa del proyecto</p>
              <div className="formGroup">
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp7"
                    value={2}
                    id="val2"
                    onClick={note7}
                  />
                  <label for="val2">2</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp7"
                    value={4}
                    id="val4"
                    onClick={note7}
                  />
                  <label for="val4">4</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp7"
                    value={6}
                    id="val6"
                    onClick={note7}
                  />
                  <label for="val6">6</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp7"
                    value={8}
                    id="val8"
                    onClick={note7}
                  />
                  <label for="val8">8</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp7"
                    value={10}
                    id="val10"
                    onClick={note7}
                  />
                  <label for="val10">10</label>
                </div>
              </div>

              <p>Vocabulario técnico y acorde a la presentación</p>
              <div className="formGroup">
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp8"
                    value={2}
                    id="val2"
                    onClick={note8}
                  />
                  <label for="val2">2</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp8"
                    value={4}
                    id="val4"
                    onClick={note8}
                  />
                  <label for="val4">4</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp8"
                    value={6}
                    id="val6"
                    onClick={note8}
                  />
                  <label for="val6">6</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp8"
                    value={8}
                    id="val8"
                    onClick={note8}
                  />
                  <label for="val8">8</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp8"
                    value={10}
                    id="val10"
                    onClick={note8}
                  />
                  <label for="val10">10</label>
                </div>
              </div>

              <p>Claridad de la presentación</p>
              <div className="formGroup">
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp9"
                    value={2}
                    id="val2"
                    onClick={note9}
                  />
                  <label for="val2">2</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp9"
                    value={4}
                    id="val4"
                    onClick={note9}
                  />
                  <label for="val4">4</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp9"
                    value={6}
                    id="val6"
                    onClick={note9}
                  />
                  <label for="val6">6</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp9"
                    value={8}
                    id="val8"
                    onClick={note9}
                  />
                  <label for="val8">8</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp9"
                    value={10}
                    id="val10"
                    onClick={note9}
                  />
                  <label for="val10">10</label>
                </div>
              </div>
              <hr />

              <h5>3. Video</h5>
              <p>
                Video estructurado y Material complementario de apoyo a la
                defensa
              </p>
              <div className="formGroup">
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp10"
                    value={2}
                    id="val2"
                    onClick={note10}
                  />
                  <label for="val2">2</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp10"
                    value={4}
                    id="val4"
                    onClick={note10}
                  />
                  <label for="val4">4</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp10"
                    value={6}
                    id="val6"
                    onClick={note10}
                  />
                  <label for="val6">6</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp10"
                    value={8}
                    id="val8"
                    onClick={note10}
                  />
                  <label for="val8">8</label>
                </div>
                <div className="formControl">
                  <input
                    type="radio"
                    name="camp10"
                    value={10}
                    id="val10"
                    onClick={note10}
                  />
                  <label for="val10">10</label>
                </div>
              </div>
            </form>
            <div className="viewResult">
              <p>{totalNote}%</p>
              puntos
              <button
                className="small-btnForm"
                onClick={() => {
                  setAssessment(dataQualify.code);
                }}
              >
                Evaluar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const InitPhoto = () => {
    return (
      <div className="initPhoto">
        <img src={check} />
        <h2>Bienvenido {cookie.get("username")}</h2>
        <h5>Panel de evaluación</h5>
      </div>
    );
  };

  //ZONA DE PROYECTOS A EVALUAR
  const ContentPanel = ({ data, isLoading }) => {
    return (
      <div className="contentPanel">
        <div className="loading">
          {isLoading && <SpinnerCircular secondaryColor="rgb(237, 237, 237)" />}
        </div>
        {!activateItem && <InitPhoto />}
        {Object.values(data).map((project) => {
          if (project.payRegister != "0") {
            if (
              project.judges == undefined ||
              !project.judges.includes(cookie.get("id"))
            ) {
              return (
                <a
                  key={project.id}
                  onClick={() => {
                    visiblePanelTrue(project);
                  }}
                  id="project"
                >
                  <div className="project">
                    <div className="cardHeader">{project.title}</div>
                    <img
                      src={`https://i.ytimg.com/vi/${project.code}/hqdefault.jpg`}
                      alt={`${project.title}`}
                    />
                    <div className="infoProject">
                      <p>{project.categoryName}</p>
                      <p>{project.matter}</p>
                      <p>Votos: {project.likes}</p>
                    </div>
                  </div>
                </a>
              );
            }
          }
        })}
      </div>
    );
  };

  //BARRA LATERAL DE NAVEGACION
  const NavbarSide = ({ data }) => {
    const [menu, setMenuVisibility] = useState(true);
    const [videoVisibility, setVideoVisibility] = useState(false);

    useEffect(() => {}, [menu]);

    const logout = () => {
      cookie.remove("id", { path: "/" });
      cookie.remove("username", { path: "/" });
      cookie.remove("email", { path: "/" });
      cookie.remove("likes", { path: "/" });
      cookie.remove("level", { path: "/" });
      cookie.remove("judge", { path: "/" });
      window.open(
        "https://ferias-ingenio-backend.vercel.app/api/auth/logout",
        "_self"
      );
    };

    const handleSideBar = () => {
      setMenuVisibility((current) => !current);
    };

    const handleActivateState = async (id) => {
      setActivateItem(id);
      loading = true;

      axios
        .post(
          "https://ferias-ingenio-backend.vercel.app/api/projects/getprojects",
          { id }
        )
        .then((res) => {
          setDataProjects(res.data);
          console.log(res.data);
          loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const VideoView = ({ videoCode }) => {
      let projectUrl = "https://www.youtube.com/embed/" + videoCode;
      return (
        <div className="videoView">
          <span
            onClick={() => {
              setVideoVisibility(false);
            }}
          >
            <FaTimesCircle />{" "}
          </span>
          <iframe
            width="100%"
            height="100%"
            src={projectUrl}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      );
    };

    return (
      <div
        className={
          menu ? `navbar-side-extended responsive-navbar` : `navbar-side`
        }
      >
        <div className="btn-sidebar" onClick={handleSideBar}>
          <FaStream />
        </div>
        <div className="campSection">
          <div className="options-categories">
            <div className="summary">
              <FaRegEdit /> Categorias a evaluar
            </div>
            {Object.values(data).map((categorie) => {
              return (
                <a
                  key={categorie.id}
                  onClick={() => handleActivateState(categorie.id)}
                >
                  <div
                    className={
                      activateItem == categorie.id
                        ? `summary-item-activated`
                        : `summary-item`
                    }
                  >
                    <FaAngleRight /> {categorie.name}
                  </div>
                </a>
              );
            })}
          </div>

          <div className="botSection">
            <a href="/categories">
              <div className="logout-btn">Todos los proyectos</div>
            </a>
            <div
              className="logout-btn"
              onClick={() => {
                setVideoVisibility(true);
              }}
            >
              Tutoriales
            </div>
            {videoVisibility && <VideoView videoCode={"g-eA0smWUak"} />}

            <div className="logout-btn" onClick={logout} title="Cerrar Sesión">
              Salir
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="PanelJudge">
      {qualify && <QualifyPanel />}
      <NavbarSide data={dataCategories} />
      <ContentPanel data={dataProjects} isLoading={loading} />
    </div>
  );
};

function Judges() {
  if (!cookie.get("judge")) {
    window.location.href = "./categories";
  }
  return (
    <div>
      <Panel />
    </div>
  );
}

export default Judges;
